export class EventType {
  public constructor() {
    this.EventType = '';
    this.Descr = '';
    this.IsPublic = false;
    this.Color = '';
  }

  public EventType: string;
  public Descr: string;
  public IsPublic: boolean;
  public Color: string;
}
